const VIGUEUR_NON_ETEN = "VIGUEUR_NON_ETEN";
const VIGUEUR_ETEN = "VIGUEUR_ETEN";
const ABROGE = "ABROGE";
const VIGUEUR = "VIGUEUR";
const VIGUEUR_DIFF = "VIGUEUR_DIFF";
const REMPLACE = "REMPLACE";
const TRANSFERE = "TRANSFERE";
const ABROGE_DIFF = "ABROGE_DIFF";
const PERIME = "PERIME";
const ANNULE = "ANNULE";
const DISJOINT = "DISJOINT";
const MODIFIE_MORT_NE = "MODIFIE_MORT_NE";
const MODIFIE = "MODIFIE";

module.exports = {
  VIGUEUR_NON_ETEN,
  VIGUEUR_ETEN,
  ABROGE,
  VIGUEUR,
  VIGUEUR_DIFF,
  REMPLACE,
  TRANSFERE,
  ABROGE_DIFF,
  PERIME,
  ANNULE,
  DISJOINT,
  MODIFIE_MORT_NE,
  MODIFIE,
};
